import { Button, Dialog, DialogTitle, TextField } from "@mui/material";
import React, { useState } from "react";
import { z } from "zod";

import { useDispatch, useSelector } from "react-redux";
import { SetShowSignIn, SetShowSignUp } from "../../redux/globalReducer";
import { ReactComponent as BrandLogoDark } from "./../../../assets/icons/brandDark.svg";
import { ReactComponent as BrandLogoLight } from "./../../../assets/icons/brandLight.svg";
import CircularProgress from "@mui/material/CircularProgress";

import "./signIn.scss";
import { toast } from "react-toastify";
import { useAuthContext } from "../../custom/providers/AuthProvider";
import useLocalStorage from "use-local-storage";

const SignIn = () => {
  const [theme] = useLocalStorage("theme", "light");
  const { signIn } = useAuthContext();
  const showSignIn = useSelector((state) => state.global.showSignIn);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [inputData, setInputData] = useState({ email: "", password: "" });

  const USER = z.object({
    email: z.string().email(),
    password: z.string().min(4),
  });

  const handleClose = () => {
    if (!loading) {
      dispatch(SetShowSignIn(false));
    }
  };

  const handleInputDataChange = (input, value) => {
    setInputData({ ...inputData, [input]: value });
  };

  const attemptSignIn = async () => {
    try {
      USER.parse(inputData);
    } catch (error) {
      toast.error(error["issues"][0]["message"]);
      return;
    }
    try {
      setLoading(true);
      await signIn(inputData);
      dispatch(SetShowSignIn(false));
    } catch (error) {
      console.log(JSON.stringify(error));
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog
        id="SignInDialog"
        open={showSignIn}
        onClose={handleClose}
        aria-labelledby="SignIn"
        aria-describedby="Proceed to SignIn"
        fullWidth
        maxWidth="sm"
      >
        <div className="d-flex w-100 flex-column flex-md-row">
          <div className="d-flex flex-column col-12 col-md-6 py-3 px-4">
            <DialogTitle id="SignIn-title" className="text-center">
              Sign In to continue
            </DialogTitle>
            <TextField
              id="email"
              label="Email"
              placeholder="john.doe@somemail.com"
              variant="outlined"
              type="text"
              className="mt-4"
              value={inputData["username"]}
              onChange={(e) => handleInputDataChange("email", e.target.value)}
            />
            <TextField
              id="password"
              label="Password"
              variant="outlined"
              type="password"
              className="mt-4"
              value={inputData["password"]}
              onChange={(e) =>
                handleInputDataChange("password", e.target.value)
              }
            />
            <div className="d-flex justify-content-end mt-4">
              <Button variant="outlined" onClick={attemptSignIn}>
                Login{" "}
                {loading ? (
                  <>
                    &nbsp;
                    <CircularProgress size="1.5rem" />
                  </>
                ) : (
                  <></>
                )}
              </Button>
            </div>

            <div
              className="d-flex justify-content-start mt-4 align-items-center"
              style={{ fontSize: "0.8rem" }}
            >
              not registered?&nbsp;
              <Button
                onClick={() => {
                  dispatch(SetShowSignIn(false));
                  dispatch(SetShowSignUp(true));
                }}
                style={{ fontSize: "0.8rem", color: "var(--primary-color)" }}
              >
                Sign Up
              </Button>
            </div>
          </div>
          <div className="d-md-flex flex-column col-12 col-md-6 my-3">
            <div className="w-100 h-100 d-flex justify-content-center align-items-center">
              {theme === "dark" ? (
                <BrandLogoLight style={{ width: "200px", height: "30px" }} />
              ) : (
                <BrandLogoDark style={{ width: "200px", height: "30px" }} />
              )}
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};
export default SignIn;
